import { fetch as fetchRaw } from '@lib/fetch';
import { getDefinedUrlSearchParams } from '@lib/util';
import type {
  ExportNetworkRequest,
  VectorSearchQuery,
  VectorSearchResponse,
} from '@retracedgmbh/modules';
import { backend } from '@services/services';
import type { FetchResult } from './types';

const fetch = (url: string, ...args: unknown[]) =>
  fetchRaw([backend.url, url], ...args);

/**
 * Triggers an async companies network export.
 * The backend responds 204 immediately and delivers the file via email
 * once the background job completes.
 */
export function networkCompaniesExport(
  body: ExportNetworkRequest,
): Promise<FetchResult<null>> {
  return fetch('/companies/export', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function getCompaniesListVectorSearch(
  queryParams: VectorSearchQuery,
): Promise<FetchResult<VectorSearchResponse>> {
  return fetch(
    `/companies/vector-search?${getDefinedUrlSearchParams(queryParams)}`,
    { method: 'GET' },
  ) as Promise<FetchResult<VectorSearchResponse>>;
}
